module.exports = __webpack_public_path__ + "static/media/contactsRed.a04b77d2.svg";